export const GROUP_BY_KEYS = ['groupId'];
